/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Thresholds_Tile_WkgInputs */

const en_ui_thresholds_tile_wkg = /** @type {(inputs: Ui_Thresholds_Tile_WkgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`W/kg`)
};

const de_ui_thresholds_tile_wkg = /** @type {(inputs: Ui_Thresholds_Tile_WkgInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`W/kg`)
};

/**
* | output |
* | --- |
* | "W/kg" |
*
* @param {Ui_Thresholds_Tile_WkgInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_thresholds_tile_wkg = /** @type {((inputs?: Ui_Thresholds_Tile_WkgInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Thresholds_Tile_WkgInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_thresholds_tile_wkg(inputs)
	return de_ui_thresholds_tile_wkg(inputs)
});